window.axios = require('axios');
import Vue from 'vue';

Vue.config.productionTip = false;

new Vue({
    components: {
    },
});

